import type { Gender } from '~/features/Profile/enums'

export enum FamilySharingStatus {
  /** Я отправил приглашение, жду ответа */
  SharingRequest = 'sharing_request',
  /** Меня пригласили, нужно принять или отклонить */
  AcceptRequest = 'accept_request',
  Refused = 'refused',
  Active = 'active',
}

export enum FamilySharingPermission {
  Read = 'read',
  Write = 'write',
}

export enum FamilySharingAppointmentScope {
  Upcoming = 'upcoming',
  Completed = 'completed',
  Actions = 'actions',
}

export enum FamilySharingMedcardScope {
  Documents = 'documents',
  FemaleCalendar = 'female_calendar',
  HealthDiaries = 'health_diaries',
  DentalPlans = 'dental_plans',
  Medforms = 'medforms',
  MedcardShare = 'medcard_share',
}

export interface FamilySharingScopeDto<Scope> {
  scope: Scope
  permissions: FamilySharingPermission | null
}

export interface FamilySharingSettingsDto {
  appointments: FamilySharingScopeDto<FamilySharingAppointmentScope>[]
  medcard: FamilySharingScopeDto<FamilySharingMedcardScope>[]
  kids: { uuid: string }[]
}

export interface FamilySharingRelatedUserDto {
  phone: string | null
  forename: string | null
  gender: Gender | null
  familyProfileUuid: string | null
  settings: FamilySharingSettingsDto | null
}

export interface FamilySharingDto {
  /** Uuid связи; используется для получения токенов доступа */
  uuid: string
  status: FamilySharingStatus
  relatedUser: FamilySharingRelatedUserDto
  me: {
    settings: FamilySharingSettingsDto
  }
}

export interface FamilySharingAccess {
  canRead: boolean
  canWrite: boolean
}

export type ScopesAccess<Scope extends string> = Partial<Record<Scope, FamilySharingAccess>>

export interface FamilySharingSettings {
  appointments: ScopesAccess<FamilySharingAppointmentScope>
  medcard: ScopesAccess<FamilySharingMedcardScope>
}

export interface FamilySharing {
  uuid: string,
  status: FamilySharingStatus,
  relatedUser: {
    phone: string | null
    forename: string | null
    gender: Gender | null
    familyProfileUuid: string | null
    kidsUuids: string[]
    settings: FamilySharingSettings | null
  }
  mySettings: FamilySharingSettings | null
}
